import makeStyles from '@mui/styles/makeStyles';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React from 'react';
import IdvFailureImage from 'images/signups/card/idv-failure.png';
import TrueLinkButton from 'react/shared/components/true_link/main/TrueLinkButton';
import TrueLinkLink from 'react/shared/components/true_link/main/TrueLinkLink';
import CardHeader from 'react/shared/components/true_link/main/form/wizard/CardHeader';
import CardText from 'react/shared/components/true_link/main/form/wizard/CardText';
import theme from 'react/shared/theme/Theme';
import { USER_TYPES } from 'react/signups/card/recipes/constants';

const useStyles = makeStyles(() => ({
  root: {
    textAlign: 'center',
  },
  card: {
    marginBottom: theme.spacing(5),
  },
  img: {
    height: '73px',
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(7),
    },
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  skipBtn: {
    marginTop: '20px',
  },
}));

export default function Failure({ onComplete, userType }) {
  const classes = useStyles();
  const isClient = userType === USER_TYPES.CLIENT;

  const connectBankAccount = () => {
    Cookies.set('connect_bank_modal', true, { expires: 1 / 1440 }); // 1 minute is 1/1440 of a day
    onComplete();
  };

  return (
    <div className={classes.root}>
      <div className={classes.card}>
        <img alt="We have some more questions" className={classes.img} src={IdvFailureImage} />
        <CardHeader>Thank you for your card order!</CardHeader>
        <CardText>
          We have just a few more questions for you. Our team will contact you soon to complete your
          order.
        </CardText>
      </div>

      {isClient && (
        <TrueLinkButton onClick={onComplete} size="large" variant="primary">
          Go to dashboard
        </TrueLinkButton>
      )}
      {!isClient && (
        <div className={classes.footer}>
          <TrueLinkButton onClick={connectBankAccount} size="large" variant="primary">
            Connect a bank account
          </TrueLinkButton>
          <TrueLinkLink className={classes.skipBtn} onClick={onComplete}>
            Skip for now
          </TrueLinkLink>
        </div>
      )}
    </div>
  );
}

Failure.propTypes = {
  onComplete: PropTypes.func.isRequired,
  userType: PropTypes.string.isRequired,
};
